import { SocialNetworks } from '../emun/social'

export const socialAuthURLs = {
  [SocialNetworks.Facebook]: '/api/v1/oauth_start-fb',
  [SocialNetworks.Google]: '/api/v1/oauth_start-gp',
  [SocialNetworks.Mail]: '/api/v1/oauth_start-mm',
  [SocialNetworks.Ok]: '/api/v1/oauth_start-ok',
  [SocialNetworks.Vk]: '/api/v1/oauth_start-vk',
  [SocialNetworks.Yandex]: '/api/v1/oauth_start-ya',
}
export const USER_AUTH = `/api/v1/user_auth`
export const RESET_PASSWORD_BY_CALL_CODE = '/api/v1/get-call-code'
export const USER_SEND_SUBMIT_EMAIL = '/api/v1/user_send-submit-email'
export const GET_MESSAGE_APPROVAL_CODE = '/api/v1/get-message-approval-code'
export const USER_PASSWORD_SEND_RESET_EMAIL = '/api/v1/user-password_send-reset-email'
export const CHECK_SMS_CODE_FOR_CONFIRM_PHONE = '/api/v1/check-sms-code-for-confirm-phone'
export const CHECK_CALL_CODE_FOR_RESET_PASSWORD = '/api/v1/check-call-code-for-reset-password'
export const CHECK_SMS_CODE_FOR_RESET_PASSWORD = '/api/v1/check-sms-code-for-reset-password'
export const EMAIL_REGISTRATION_CHECK = '/api/v1/email-registration_check'
export const USER_GET = '/api/v1/user_get'
export const BRANCH_GET_ALL = '/api/v1/branch_get-all'
export const IS_CAPTCHA_NEEDED = '/api/v1/is-captcha-needed'
export const USER_ADD = '/api/v1/user_add'
export const USER_CHANGE = '/api/v1/user_change'
export const PHONE_CHECK_CALL_CODE = '/api/v1/check-call-code-for-confirm-phone'
export const PHONE_CHECK = '/api/v1/phone_check'
export const POST_FIND_BY_NAME = '/api/v1/post_find-by-name'
export const STUDENTS_POST_FIND_BY_NAME = '/api/v1/post_students-find-by-name'
export const STUDENTS_OR_TEACHER_POST_FIND_BY_NAME = '/api/v1/post_students-lecturers-find-by-name'
export const INSTITUTE_FIND_BY_NAME = '/api/v1/institute_get-list'
export const SPECIALTY_FIND_BY_NAME = '/api/v1/specialty_get-list'
export const DEGREE_GET_LIST = '/api/v1/degree_get-list'
export const REGION_GET_LIST = '/api/v1/region_get-list'
export const GET_ORGANIZATION_LIST = '/api/v1/organization_get-list'
export const GET_UNIVERSITY_LIST = '/api/v1/university_get-list'
export const TAXATION_GET_ALL = '/api/v1/taxation_get-all'
export const STAFF_GET_ALL = '/api/v1/staff_get-all'
export const VALIDATE_RESET_CODE = '/api/v1/user-password_validate-reset-code'
export const CHANGE_USER_PASSWORD = '/api/v1/user-password_change'
export const USER_UPDATE_PASSWORD = '/api/v1/auth-user-password_change'
